import { Col } from 'reactstrap';
import ExtraFields from '../../../SectionsMaintainer/parts/ExtraFields';

export function TeachersFields({
  t,
  prefix,
  searchTeachers,
  supportsOnline,
  supportsPresential,
}: any) {
  return (
    <Col xs={12} md={6}>
      <ExtraFields
        title="teachers"
        inputLabel={t(`${prefix}.teacher`)}
        search={searchTeachers}
        buttonLabel={t(`${prefix}.addTeacher`)}
        supportsOnline={supportsOnline}
        supportsPresential={supportsPresential}
      />
    </Col>
  );
}

export function AssistantsFields({
  t,
  prefix,
  searchAssistants,
  supportsOnline,
  supportsPresential,
}: any) {
  return (
    <Col xs={12} md={6}>
      <ExtraFields
        title="assistants"
        inputLabel={t(`${prefix}.assistant`)}
        search={searchAssistants}
        buttonLabel={t(`${prefix}.addAssistant`)}
        supportsOnline={supportsOnline}
        supportsPresential={supportsPresential}
      />
    </Col>
  );
}
